import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileWebSignatureControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        element.find("div").css("width","100%");
        element[0].style.textAlign = "left";
    }
}

const mobileWebSignatureControlView = new MobileWebSignatureControlView();
export default mobileWebSignatureControlView;